import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiUser, FiLink, FiClipboard, FiZap } from 'react-icons/fi';
import './Features.css';

const features = [
  {
    title: 'Заменяет киоск и сотрудника',
    description: 'Аватар — это интерактивный киоск с человеческим лицом. Он легко находит общий язык с любым клиентом и говорит на 12 языках без перевода базы знаний.',
    Icon: FiUser,
    color: '#0071e3',
  },
  {
    title: 'Подключается к вашим системам',
    description: 'Получает информацию с сайтов, телеграм-каналов и внешних API. Всегда отвечает актуально, потому что данные обновляются в реальном времени.',
    Icon: FiLink,
    color: '#0071e3',
  },
  {
    title: 'Оформляет заявки и регистрирует',
    description: 'Собирает контакты, оформляет заявки, регистрирует клиентов на мероприятия. Все данные сразу попадают в вашу CRM или базу данных.',
    Icon: FiClipboard,
    color: '#0071e3',
  },
  {
    title: 'Настройка без программистов',
    description: 'Всё управление через личный кабинет: внешность, имя, инструкции, база знаний. Создайте аватара как персонажа в игре — за 15 минут.',
    Icon: FiZap,
    color: '#0071e3',
  },
];

const Features = () => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <section className="features-new" id="features" ref={ref}>
      <div className="features-new-container">
        <motion.div
          className="features-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="section-title">Почему выбирают нас</h2>
          <p className="section-subtitle">Ценность для вашего бизнеса</p>
        </motion.div>

        <div className="features-layout">
          <motion.div
            className="features-grid"
            initial={{ opacity: 0 }}
            animate={inView ? { opacity: 1 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            {features.map((feature, index) => (
              <motion.div
                key={feature.title}
                className="feature-card"
                initial={{ opacity: 0, y: 30 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.6, delay: 0.3 + index * 0.1 }}
                whileHover={{ y: -8 }}
                style={{ '--feature-color': feature.color }}
              >
                <div className="feature-icon-wrapper">
                  <feature.Icon className="feature-icon" aria-hidden="true" />
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </motion.div>
            ))}
          </motion.div>

          <motion.div
            className="features-screenshot"
            initial={{ opacity: 0, x: 50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.5 }}
          >
            <div className="screenshot-wrapper">
              <img 
                src="/images/screenshots/avatar_setup_website.png" 
                alt="Личный кабинет PerformerAI"
                className="screenshot-main"
              />
              <img 
                src="/images/screenshots/avatar_setup_db.png" 
                alt="Настройка базы знаний"
                className="screenshot-secondary"
              />
            </div>
            <p className="screenshot-caption">Личный кабинет для управления аватарами</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Features;
